import { GET } from './Clients';

const PRODUCT_API_PREFIX = '/marketplace/product/v2';

export const getManufacturer = async (code) =>
  GET({
    url: `${PRODUCT_API_PREFIX}/manufacturer`,
    params: {
      q: JSON.stringify({ code }),
    },
  });

export const getManufacturers = async ({ offset = 0, limit = 100, ids = [], codes = [], getTotal = false, isAuth, isBasic }) => {
  return GET({
    url: `${PRODUCT_API_PREFIX}/manufacturer/list`,
    params: {
      offset,
      limit: codes.length > 0 ? (ids.length > 0 ? ids.length : codes.length) : limit,
      ids: ids.join(','),
      codes: codes.join(','),
      getTotal,
    },
    isAuth,
    isBasic,
  });
};

